import script from "./DialogItem.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogItem.vue?vue&type=script&setup=true&lang=js"

import "./DialogItem.vue?vue&type=style&index=0&id=f6af91f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6af91f8"]])

export default __exports__